// extracted by mini-css-extract-plugin
export default {"modal":"DeleteWarningModal_modal__L0FNg"};